import { LOCALE, type LOCALE as Locale } from '../../../../../../i18n'
import { TENANT, type TENANT as Tenant } from '../../../../../../tenant'

export type ProductHeadBioCertificateLocation = 'pilsen' | 'settala' | 'sevenum'

type ProductHeadBioCertificateRow = {
  certificateNumber: string
  fileName: string
  location: ProductHeadBioCertificateLocation
}

const BELGIUM_CERTIFICATE_PATH_PREFIX = '/media/temp/sa-be/media/pdf/'
const CERTIFICATE_PATH_PREFIX = '/media/pdf/'

const CZECH_PILSEN_CERTIFICATE_ROW: ProductHeadBioCertificateRow = {
  certificateNumber: 'CZ-BIO-002',
  fileName: '20261120%20cert_EU_BIO_certificaat_Shop-Apotheke%20Pilsen_DE.pdf',
  location: 'pilsen',
}

const DUTCH_SEVENUM_CERTIFICATE_ROW: ProductHeadBioCertificateRow = {
  certificateNumber: 'NL-BIO-01',
  fileName: '20280101%20cert_EU_BIO_certificaat_Shop-Apotheke_NL.pdf',
  location: 'sevenum',
}

const FRENCH_SEVENUM_CERTIFICATE_ROW: ProductHeadBioCertificateRow = {
  certificateNumber: 'NL-BIO-01',
  fileName: '20280101%20cert_EU_BIO_certificaat_Shop-Apotheke_FR.pdf',
  location: 'sevenum',
}

const GERMAN_SEVENUM_CERTIFICATE_ROW: ProductHeadBioCertificateRow = {
  certificateNumber: 'NL-BIO-01',
  fileName: '20280101%20cert_EU_BIO_certificaat_Shop-Apotheke_DE.pdf',
  location: 'sevenum',
}

const ITALIAN_SETTALA_CERTIFICATE_ROW: ProductHeadBioCertificateRow = {
  certificateNumber: 'IT-BIO-009',
  fileName: '20290511%20cert_EU_BIO_certicate_Redcare%20SRL_IT.pdf',
  location: 'settala',
}

const AUSTRIAN_CERTIFICATE_ROWS = [CZECH_PILSEN_CERTIFICATE_ROW]
const COM_CERTIFICATE_ROWS = [
  GERMAN_SEVENUM_CERTIFICATE_ROW,
  CZECH_PILSEN_CERTIFICATE_ROW,
]
const FRENCH_CERTIFICATE_ROWS = [FRENCH_SEVENUM_CERTIFICATE_ROW]
const ITALIAN_CERTIFICATE_ROWS = [ITALIAN_SETTALA_CERTIFICATE_ROW]

export const getProductHeadBioCertificateRows = ({
  locale,
  tenant,
}: {
  locale: Locale
  tenant: Tenant
}): ProductHeadBioCertificateRow[] => {
  switch (tenant) {
    case TENANT.AT: {
      return AUSTRIAN_CERTIFICATE_ROWS
    }
    case TENANT.BE: {
      return [
        locale === LOCALE.NL_BE
          ? DUTCH_SEVENUM_CERTIFICATE_ROW
          : FRENCH_SEVENUM_CERTIFICATE_ROW,
      ]
    }
    case TENANT.CH: {
      return [
        locale === LOCALE.FR_CH
          ? FRENCH_SEVENUM_CERTIFICATE_ROW
          : GERMAN_SEVENUM_CERTIFICATE_ROW,
      ]
    }
    case TENANT.COM: {
      return COM_CERTIFICATE_ROWS
    }
    case TENANT.FR: {
      return FRENCH_CERTIFICATE_ROWS
    }
    case TENANT.IT: {
      return ITALIAN_CERTIFICATE_ROWS
    }
    default: {
      return COM_CERTIFICATE_ROWS
    }
  }
}

export const getProductHeadBioCertificateFilePath = ({
  fileName,
  tenant,
}: {
  fileName: string
  tenant: Tenant
}): string => {
  const pathPrefix =
    tenant === TENANT.BE
      ? BELGIUM_CERTIFICATE_PATH_PREFIX
      : CERTIFICATE_PATH_PREFIX

  return `${pathPrefix}${fileName}`
}
